import Timeline from './Timeline';
import PlanToggle from './PlanToggle';
import ReasoningPanel from './ReasoningPanel';
import NavigationGuide from './NavigationGuide';
import Button from '../shared/Button';
import useTripStore from '../../context/TripStore';

const Itinerary = () => {
  const { itinerary, setCurrentStep, reset, navigation, startNavigation } = useTripStore();
  const activePlan = itinerary.activePlan === 'a' ? itinerary.planA : itinerary.planB;
  const isNavigating = navigation?.isActive;

  const handleNewTrip = () => {
    if (window.confirm('Start a new trip? This will clear your current itinerary.')) {
      reset();
      setCurrentStep('setup');
    }
  };

  const handleBack = () => {
    setCurrentStep('timeblocks');
  };

  const handleStartTrip = () => {
    startNavigation();
  };

  if (!itinerary.planA && !itinerary.planB) {
    return (
      <div className="p-6">
        <div className="border border-gray-300 p-4 mb-4">
          <p className="text-xs font-light text-gray-600">No itinerary generated yet. Please go back and generate one.</p>
        </div>
        <Button onClick={handleBack}>Back to Time Blocks</Button>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-light tracking-tight">
          {isNavigating ? 'Navigation' : 'Your Itinerary'}
        </h1>
        {!isNavigating ? (
          <Button onClick={handleStartTrip}>
            Start Trip
          </Button>
        ) : (
          <Button variant="secondary" onClick={handleNewTrip} className="text-xs py-1 px-2">
            New Trip
          </Button>
        )}
      </div>

      {!isNavigating && (
        <div className="mb-6">
          <PlanToggle />
        </div>
      )}

      {/* Navigation Guide - shows when navigating */}
      {isNavigating ? (
        <NavigationGuide />
      ) : (
        <>
          {/* Start Trip CTA - prominent */}
          <div className="bg-gray-900 text-white p-6 rounded mb-6">
            <h2 className="text-lg font-light mb-2">Ready to start your trip?</h2>
            <p className="text-xs font-light text-gray-300 mb-4">
              Follow your itinerary step-by-step with turn-by-turn navigation.
            </p>
            <Button onClick={handleStartTrip} className="w-full bg-white text-gray-900 hover:bg-gray-100">
              Start Trip
            </Button>
          </div>

          {/* Static Timeline - shows when not navigating */}
          <div className="space-y-4 mb-6">
            <div>
              <h2 className="text-xs font-light uppercase tracking-wide text-gray-600 mb-3">Timeline</h2>
              <Timeline />
            </div>
          </div>

          {itinerary.reasoning && (
            <div className="mb-6">
              <ReasoningPanel
                reasoning={itinerary.reasoning}
                warnings={activePlan?.warnings}
              />
            </div>
          )}
        </>
      )}

      {!isNavigating && (
        <div className="flex justify-between">
          <Button variant="secondary" onClick={handleBack}>
            Back
          </Button>
        </div>
      )}
    </div>
  );
};

export default Itinerary;

